export interface FeatureFlags {
  isServiceMenuEnabled?: boolean
  isRoomEnabled?: boolean
  isEquipmentEnabled?: boolean
}

const defaultFeatureFlags: FeatureFlags = {
  isServiceMenuEnabled: false,
  isRoomEnabled: false,
  isEquipmentEnabled: false,
}

export default class CalendarLocationSettings {
  private data: any = {}

  constructor(data: any) {
    this.data = data
  }

  get featureFlags(): FeatureFlags {
    return this.data?.featureFlags ?? defaultFeatureFlags
  }

  get showArchivedServicesBanner(): boolean {
    return this.data?.showArchivedServicesBanner ?? true
  }
}
